module.exports = __webpack_public_path__ + "img/user.fc094321.jpg";